import { useEffect } from 'react';
import { useNavigationType } from 'react-router';

/**
 * Starts a front-door page at the top when a link brings the reader here.
 *
 * The shell has no scroll restoration, so a client-side navigation keeps the previous
 * page's scroll offset. The links between /about and /about/stack sit far down each
 * page, so without this the reader lands near the bottom of the next one. Back and
 * forward (a POP) are left alone, so the browser can put the reader back where they were.
 */
export function useScrollToTopOnArrival(): void {
  const navigationType = useNavigationType();
  useEffect(() => {
    if (navigationType !== 'POP') window.scrollTo(0, 0);
    // Only on arrival (mount), not when a later navigation changes the type.
  }, []);
}
